(function () {
  function toNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function getHeaderEl() {
    return (
      document.querySelector(".header-static") ||
      document.querySelector("header.site-header") ||
      document.querySelector(".site-header")
    );
  }

  function getHeaderHeight() {
    var header = getHeaderEl();
    return header ? header.offsetHeight : 0;
  }

  function getHeaderBottom() {
    var header = getHeaderEl();
    if (!header) return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  }

  function getDocumentBottom(el) {
    if (!el) return 0;
    return el.getBoundingClientRect().bottom + (window.scrollY || window.pageYOffset || 0);
  }

  function isHeaderPinned() {
    var header = getHeaderEl();
    if (!header) return false;

    var rect = header.getBoundingClientRect();
    if (rect.bottom <= 0) return false;

    var body = document.body;
    if (body.classList.contains("header-no-fixed") || body.classList.contains("template-product")) {
      return rect.top >= 0;
    }

    var inlineTop = header.style.top;
    if (inlineTop !== "") {
      var topValue = parseFloat(inlineTop);
      if (!Number.isNaN(topValue)) {
        return topValue <= 0;
      }
    }

    return rect.top <= 1;
  }

  function normalizeTargetSelector(raw) {
    if (!raw) return "";
    var source = String(raw).trim();
    if (!source) return "";
    if (source.startsWith(".") || source.startsWith("#")) return source;
    var firstToken = source.split(/\s+/)[0];
    return "." + firstToken.replace(/^\./, "");
  }

  function initOpenearPageNav(root) {
    if (!root || root.dataset.openearNavReady === "true") return;
    root.dataset.openearNavReady = "true";

    var iconTabs = Array.prototype.slice.call(root.querySelectorAll(".openear-pagenav__tab--icon"));
    var labelTabs = Array.prototype.slice.call(root.querySelectorAll(".openear-pagenav__tab--label"));
    var tabs = iconTabs.length ? iconTabs : labelTabs;
    var lineFill = root.querySelector(".openear-pagenav__line-fill");
    var line = root.querySelector(".openear-pagenav__line");
    var scrollContainer = root.querySelector(".openear-pagenav__viewport");
    if (!tabs.length || !lineFill || !line) return;

    var extraOffset = toNumber(root.dataset.extraOffset, 12);
    var mobileBreakpoint = toNumber(root.dataset.mobileBreakpoint, 500);
    var targets = [];
    var iconRatios = [];
    var scrollTicking = false;
    var resizeTicking = false;
    var activeIndex = -1;
    var bannerTriggerBottom = 0;
    var programmaticScrollId = 0;
    var pendingScrollIndex = -1;

    function getScrollTop() {
      return window.scrollY || window.pageYOffset || 0;
    }

    function getTargetDocumentTop(target) {
      if (!target) return 0;
      return target.getBoundingClientRect().top + getScrollTop();
    }

    function getTargetDocumentBottom(target) {
      if (!target) return 0;
      return target.getBoundingClientRect().bottom + getScrollTop();
    }

    function getStickyOffset() {
      var nav = root.querySelector(".openear-pagenav");
      var navHeight = nav ? nav.offsetHeight : 0;
      var headerOffset = root.classList.contains("is-fixed") ? 0 : getHeaderBottom();
      return headerOffset + navHeight + extraOffset;
    }

    function updateStickyTopVar() {
      var nav = root.querySelector(".openear-pagenav");
      var navHeight = nav ? nav.offsetHeight : 0;
      root.style.setProperty("--openear-nav-height", navHeight + "px");
    }

    function resolveBannerTriggerBottom() {
      var previousSection = root.parentElement ? root.parentElement.previousElementSibling : null;
      if (previousSection) {
        bannerTriggerBottom = getDocumentBottom(previousSection);
        return;
      }

      var bannerSection =
        document.querySelector(".section-pillar-page-banner") ||
        document.querySelector("[class*='section-pillar-page-banner']");
      bannerTriggerBottom = bannerSection ? getDocumentBottom(bannerSection) : 0;
    }

    function resolveTargets() {
      targets = tabs.map(function (tab) {
        var selector = normalizeTargetSelector(tab.dataset.targetClass);
        if (!selector) return null;
        return document.querySelector(selector);
      });
    }

    function recalcIconRatios() {
      var lineRect = line.getBoundingClientRect();
      var lineWidth = lineRect.width || 1;
      var ratioTabs = iconTabs.length ? iconTabs : labelTabs;

      iconRatios = ratioTabs.map(function (tab) {
        var rect = tab.getBoundingClientRect();
        var center = rect.left + rect.width / 2;
        return clamp((center - lineRect.left) / lineWidth, 0, 1);
      });
    }

    function isMobileLayout() {
      return window.innerWidth <= mobileBreakpoint;
    }

    function syncLayoutMode() {
      var mobile = isMobileLayout();
      root.classList.toggle("is-mobile-layout", mobile);
      root.style.setProperty("--openear-icon-1", mobile ? "17.95%" : "25%");
      root.style.setProperty("--openear-icon-2", mobile ? "49.25%" : "50%");
      root.style.setProperty("--openear-icon-3", mobile ? "83.05%" : "75%");

      if (scrollContainer) {
        scrollContainer.scrollLeft = mobile ? 0 : scrollContainer.scrollLeft;
      }
    }

    function recalcAnchorPoints() {
      syncLayoutMode();
      resolveBannerTriggerBottom();
      updateStickyTopVar();
      recalcIconRatios();
    }

    function getSectionAnchors() {
      var anchors = [];
      var i;

      for (i = 0; i < targets.length; i += 1) {
        if (!targets[i] || iconRatios[i] === undefined) continue;
        anchors.push({
          index: i,
          top: getTargetDocumentTop(targets[i]),
          bottom: getTargetDocumentBottom(targets[i]),
          ratio: iconRatios[i]
        });
      }

      return anchors;
    }

    function calculateActiveIndex(scrollTop) {
      var activationY = scrollTop + getStickyOffset();
      var active = -1;
      var i;

      for (i = 0; i < targets.length; i += 1) {
        var target = targets[i];
        if (!target) continue;
        if (activationY >= getTargetDocumentTop(target) - 2) {
          active = i;
        }
      }

      return active;
    }

    function calculateLineProgress(scrollTop) {
      var activationY = scrollTop + getStickyOffset();
      var anchors = getSectionAnchors();
      var i;

      if (!anchors.length || !iconRatios.length) return 0;
      if (activationY < anchors[0].top - 2) return 0;

      for (i = 0; i < anchors.length - 1; i += 1) {
        var current = anchors[i];
        var next = anchors[i + 1];

        if (activationY < next.top) {
          var range = next.top - current.top;
          if (range <= 0) return current.ratio;
          var segment = clamp((activationY - current.top) / range, 0, 1);
          return current.ratio + segment * (next.ratio - current.ratio);
        }
      }

      var last = anchors[anchors.length - 1];
      if (last.bottom <= last.top) return last.ratio;
      if (activationY >= last.bottom) return 1;

      var tailRange = last.bottom - last.top;
      var tail = clamp((activationY - last.top) / tailRange, 0, 1);
      return last.ratio + tail * (1 - last.ratio);
    }

    function syncFixedState() {
      if (root.getAttribute("data-openear-nav-scrolling") === "true") {
        updateStickyTopVar();
        return;
      }

      if (document.body.classList.contains("pillar-nav-2-sticky")) {
        root.classList.remove("is-fixed");
        document.body.classList.remove("openear-pagenav-replace-header");
        updateStickyTopVar();
        return;
      }

      var shouldFix = false;
      if (bannerTriggerBottom > 0) {
        var triggerTop = Math.max(0, bannerTriggerBottom - getHeaderHeight());
        shouldFix = getScrollTop() >= triggerTop;
      } else {
        shouldFix = isHeaderPinned();
      }

      root.classList.toggle("is-fixed", shouldFix);
      document.body.classList.toggle("openear-pagenav-replace-header", shouldFix);
      updateStickyTopVar();
    }

    function calculateState(scrollTop) {
      var lineProgress = calculateLineProgress(scrollTop);
      var currentActive = calculateActiveIndex(scrollTop);

      return {
        active: currentActive,
        lineProgress: clamp(lineProgress, 0, 1)
      };
    }

    function ensureActiveTabVisible(nextActive) {
      if (!isMobileLayout() || nextActive < 0 || !scrollContainer) return;
      if (scrollContainer.scrollWidth <= scrollContainer.clientWidth + 1) return;
      var iconTab = iconTabs[nextActive];
      if (!iconTab) return;
      var scrollerRect = scrollContainer.getBoundingClientRect();
      var targetRect = iconTab.getBoundingClientRect();
      var targetLeft =
        scrollContainer.scrollLeft +
        (targetRect.left - scrollerRect.left) -
        (scrollerRect.width - targetRect.width) / 2;
      scrollContainer.scrollTo({
        left: Math.max(0, targetLeft),
        behavior: "smooth"
      });
    }

    function setTabState(tab, isActive) {
      tab.classList.toggle("is-active", isActive);
      tab.classList.remove("is-complete");
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    }

    function render(state) {
      tabs.forEach(function (tab, index) {
        var isActive = index === state.active;
        setTabState(tab, isActive);
        if (labelTabs[index]) {
          setTabState(labelTabs[index], isActive);
        }
        if (iconTabs[index] && iconTabs[index] !== tab) {
          setTabState(iconTabs[index], isActive);
        }
      });

      lineFill.style.setProperty("--line-progress", state.lineProgress.toFixed(4));
      root.style.setProperty("--line-progress", state.lineProgress.toFixed(4));

      if (state.active !== activeIndex) {
        activeIndex = state.active;
        ensureActiveTabVisible(activeIndex);
      }
    }

    function onScroll() {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () {
        var scrollTop = getScrollTop();
        syncFixedState();
        var state = calculateState(scrollTop);
        if (root.getAttribute("data-openear-nav-scrolling") === "true" && pendingScrollIndex >= 0) {
          state.active = pendingScrollIndex;
        }
        render(state);
        scrollTicking = false;
      });
    }

    function onResize() {
      if (resizeTicking) return;
      resizeTicking = true;
      requestAnimationFrame(function () {
        resolveTargets();
        recalcAnchorPoints();
        var scrollTop = getScrollTop();
        syncFixedState();
        render(calculateState(scrollTop));
        resizeTicking = false;
      });
    }

    function trackTabClick(index) {
      var labelTab = labelTabs[index];
      if (!labelTab) return;

      var labelEl = labelTab.querySelector(".openear-pagenav__label");
      var buttonName = labelEl && labelEl.textContent
        ? labelEl.textContent.trim()
        : labelTab.textContent.trim();

      if (!buttonName) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: "ga4Event",
        event_name: "select_content_category",
        event_parameters: {
          content_type: "pageNav",
          button_name: buttonName
        }
      });
    }

    function getScrollDestination(index) {
      if (!targets[index]) return null;
      syncFixedState();
      updateStickyTopVar();
      return Math.max(
        0,
        Math.round(getTargetDocumentTop(targets[index]) - getStickyOffset())
      );
    }

    function estimateScrollDuration(destinationTop) {
      var distance = Math.abs(destinationTop - getScrollTop());
      return Math.min(1400, Math.max(450, distance * 0.55));
    }

    function finishProgrammaticScroll(scrollId) {
      if (scrollId !== programmaticScrollId) return;

      var targetIndex = pendingScrollIndex;
      pendingScrollIndex = -1;
      root.removeAttribute("data-openear-nav-scrolling");

      document.dispatchEvent(new CustomEvent("openear-pagenav-scroll-end"));

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (targetIndex < 0) return;
          resolveTargets();
          syncFixedState();
          updateStickyTopVar();

          var destinationTop = getScrollDestination(targetIndex);
          if (destinationTop !== null) {
            var diff = Math.abs(getScrollTop() - destinationTop);
            if (diff > 8) {
              window.scrollTo({ top: destinationTop, behavior: "auto" });
            }
          }

          render(calculateState(getScrollTop()));
        });
      });
    }

    function scrollToTarget(index) {
      if (!targets[index]) return;

      var scrollId = ++programmaticScrollId;
      var destinationTop = getScrollDestination(index);
      if (destinationTop === null) return;

      pendingScrollIndex = index;
      root.setAttribute("data-openear-nav-scrolling", "true");

      window.scrollTo({
        top: destinationTop,
        behavior: "smooth"
      });

      var optimisticState = calculateState(getScrollTop());
      optimisticState.active = index;
      render(optimisticState);

      var scrollDuration = estimateScrollDuration(destinationTop);
      var finished = false;

      function completeOnce() {
        if (finished) return;
        finished = true;
        finishProgrammaticScroll(scrollId);
      }

      if ("onscrollend" in window) {
        window.addEventListener("scrollend", completeOnce, { once: true });
      }

      window.setTimeout(completeOnce, scrollDuration + 80);
    }

    function bindTab(tab, index) {
      tab.addEventListener("click", function () {
        trackTabClick(index);
        scrollToTarget(index);
      });
    }

    tabs.forEach(bindTab);
    labelTabs.forEach(function (tab, index) {
      if (tabs.indexOf(tab) === -1) {
        bindTab(tab, index);
      }
    });

    resolveTargets();
    recalcAnchorPoints();
    syncFixedState();
    render(calculateState(getScrollTop()));

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize);
    window.addEventListener("load", onResize);

    document.addEventListener("pillar-nav-2-sticky-change", function (event) {
      var isProductSticky = !!(event.detail && event.detail.sticky);

      if (root.getAttribute("data-openear-nav-scrolling") === "true") {
        return;
      }

      if (isProductSticky) {
        syncFixedState();
        render(calculateState(getScrollTop()));
        return;
      }

      requestAnimationFrame(function () {
        syncFixedState();
        render(calculateState(getScrollTop()));
      });
    });
  }

  function boot() {
    var navSections = document.querySelectorAll(".section-openear-pagenav");
    navSections.forEach(initOpenearPageNav);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
